import { Grid } from '@mui/material';
import { MembershipContext } from 'components/MembershipGuard';
import { useSnackbar } from 'notistack';
import React, { useCallback, useContext, useState } from 'react';
import { CurrentMembership } from 'store/types/Membership';
import SubscriptionStatus from 'store/enums/SubscriptionStatus';
import MembershipService from 'services/api/MembershipService';
import { defaultGridContainerProps, defaultGridItemProps, defaultSnackbarErrorProps } from 'util/Layout';
import EditPaymentMethodModal from 'components/payments/EditPaymentMethodModal';
import MembershipStatusCard from './MembershipStatusCard';
import { ParametersContext } from 'components/ParametersGuard';

const MembershipInfoPage: React.FunctionComponent = () => {
  const currentMembership: CurrentMembership = useContext(MembershipContext);
  const { enqueueSnackbar } = useSnackbar();
  const [addMethodModalOpen, setAddMethodModalOpen] = useState<boolean>(false);
  const {
    membership: { membershipPageHeader },
  } = useContext(ParametersContext);
  const { status, setCurrentMembership } = currentMembership;
  const isNonMember: boolean = status === SubscriptionStatus.NonMember;

  const changeAutoRenewal = useCallback(
    (isEnabled: boolean) => {
      MembershipService.changeAutoRenewal(isEnabled)
        .then(() => {
          enqueueSnackbar(isEnabled ? 'Auto-Renewal successfully turned on' : 'Auto-Renewal successfully turned off', {
            variant: 'success',
          });
          setCurrentMembership({ autoRenewal: isEnabled });
        })
        .catch((errorMessage: string) => {
          enqueueSnackbar(errorMessage, defaultSnackbarErrorProps);
        });
    },
    [setCurrentMembership, enqueueSnackbar]
  );

  const handleAddMethodModalClose = useCallback(() => {
    setAddMethodModalOpen(false);
  }, []);

  const handleNewMethodAdded = useCallback(() => {
    setAddMethodModalOpen(false);
    changeAutoRenewal(true);
  }, [changeAutoRenewal]);

  return (
    <>
      <Grid {...defaultGridContainerProps}>
        {isNonMember && (
          <Grid {...defaultGridItemProps}>
            {membershipPageHeader && <p dangerouslySetInnerHTML={{ __html: membershipPageHeader }} />}
          </Grid>
        )}
        <Grid {...defaultGridItemProps}>
          <MembershipStatusCard />
        </Grid>
      </Grid>
      <EditPaymentMethodModal
        open={addMethodModalOpen}
        onSubmit={handleNewMethodAdded}
        onClose={handleAddMethodModalClose}
        makeDefaultPreselected={true}
      />
    </>
  );
};
export default MembershipInfoPage;
